/**
 * Memoria device-local de "ya pedimos el mic solos y rebotó".
 *
 * Por qué existe (decisión del dueño, 2026-09-17): el pre-flight pide el mic
 * en CADA entrada a una conversación, sin gesto del user — y los browsers
 * cuentan esos descartes. Chrome (desktop y Android) auto-bloquea el origen al
 * TERCER descarte ("permissions embargo", ~7 días), y durante ese embargo no
 * hay prompt posible: ni el nuestro ni ninguno. O sea que preguntar sola en
 * cada entrada le quema al user sus tres oportunidades en aperturas que él no
 * pidió, y lo deja sin ninguna para cuando SÍ quiere dar el permiso.
 *
 * Con este flag, el pedido automático es **uno solo**: la primera vez pregunta
 * como siempre; si rebota, las entradas siguientes abren directo en texto con
 * el botón del aviso, y el prompt del browser sale únicamente de un tap
 * deliberado. Se limpia en cuanto el mic vuelve a funcionar, así una revocación
 * futura vuelve a tener su pedido automático.
 *
 * Device-local a propósito (localStorage, no prefs de DB): el permiso es del
 * browser en ESTA máquina — sincronizarlo entre dispositivos describiría mal la
 * realidad del que abre la app en otro lado.
 */

const MIC_AUTO_ASK_KEY = 'orborix.speak.micAutoAskDenied';

/** `true` si un pedido AUTOMÁTICO de mic ya rebotó en este browser. */
export function micAutoAskDenied(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(MIC_AUTO_ASK_KEY) === '1';
  } catch {
    // Safari privado / storage bloqueado: sin memoria, se comporta como antes.
    return false;
  }
}

export function markMicAutoAskDenied(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(MIC_AUTO_ASK_KEY, '1');
  } catch {
    // idem: la memoria es una optimización, no un requisito.
  }
}

/** El mic volvió a funcionar → el próximo problema vuelve a tener pedido automático. */
export function clearMicAutoAskDenied(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(MIC_AUTO_ASK_KEY);
  } catch {
    // idem.
  }
}
